"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageUnderstandingFailureSchema = exports.PackageUnderstandingFailureKind = void 0;
const zod_1 = require("zod");
var PackageUnderstandingFailureKind;
(function (PackageUnderstandingFailureKind) {
    PackageUnderstandingFailureKind["Transient"] = "transient";
    PackageUnderstandingFailureKind["Permanent"] = "permanent";
})(PackageUnderstandingFailureKind || (exports.PackageUnderstandingFailureKind = PackageUnderstandingFailureKind = {}));
exports.PackageUnderstandingFailureSchema = zod_1.z.object({
    kind: zod_1.z.nativeEnum(PackageUnderstandingFailureKind),
    fileId: zod_1.z.string().nullable(),
    workflowId: zod_1.z.string(),
    reason: zod_1.z.string(),
    failedAt: zod_1.z.string(),
});
//# sourceMappingURL=package-understanding-failure.js.map